import { render, staticRenderFns } from "./ControlePedidosCardDetails.vue?vue&type=template&id=6ad9215a"
import script from "./ControlePedidosCardDetails.vue?vue&type=script&lang=js"
export * from "./ControlePedidosCardDetails.vue?vue&type=script&lang=js"
import style0 from "./ControlePedidosCardDetails.vue?vue&type=style&index=0&id=6ad9215a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports